import React from 'react'
import zingchart from 'zingchart/es6'
import propTypes from 'prop-types'

// Import components
import ZingChart from 'zingchart-react'

import PieChartConfig from './PieChartConfiguration'
import { useEffect } from 'react'

/**
 * Dashboard card component
 * @param {*} props
 */
const PieChartCard = (props) => {
	const chartId = props.chartId

	useEffect(() => {
		const handleNodeClick = (e) => {
			const index = e.plotindex
			const series = props.series

			if (!series || series.length === 0) return
			const identifier = series[index]?.identifier

			if (props.onSliceClick) {
				props.onSliceClick(identifier)
			}
		}

		zingchart.bind(chartId, 'node_click', handleNodeClick)

		return () => {
			zingchart.unbind(chartId, 'node_click', handleNodeClick)
		}
	}, [props, props.series, chartId])

	const charData = PieChartConfig(props.title, props.subtitle, props.series, props.mainColor, props.secondaryColor, props.percentage)

	return (
		<div>
			<ZingChart
				data={charData}
				id={props.chartId}
			/>
		</div>
	)
}
PieChartCard.propTypes = {
	mainColor: propTypes.string.isRequired,
	secondaryColor: propTypes.string.isRequired,
	totalServices: propTypes.number.isRequired,
	percentajeValue: propTypes.number.isRequired,
	label: propTypes.string.isRequired,
	height: propTypes.number.isRequired
}
PieChartCard.defaultProps = {
	mainColor: '#D3D3D3',
	secondaryColor: '#ADADAD',
	totalServices: 0,
	percentajeValue: 0,
	label: 'label',
	height: 180
}
export default PieChartCard
